import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { Report } from 'src/app/_models/report';

@Component({
    selector: 'app-assessmentRoll',
    templateUrl: './assessmentRoll.component.html',
    styleUrls: ['./assessmentRoll.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssessmentRollComponent implements OnInit {
  items: Report[];
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.apiService.getRoll().subscribe(data => {
      this.items = data;
      console.log(this.items)
    })
   
  }

}
